(function () {
  'use strict';

  function activateFallback(gallery) {
    var navigation = gallery.querySelector('[data-gallery-navigation]');
    var viewer = gallery.querySelector('[data-gallery-viewer]');

    if (!navigation || !viewer || !navigation.classList.contains('loading')) return;

    navigation.classList.remove('loading');
    navigation.setAttribute('data-ge-gallery-fallback', 'true');

    navigation.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('[data-gallery-thumbnail]');
      if (!thumbnail || !navigation.contains(thumbnail)) return;

      event.preventDefault();
      var index = thumbnail.getAttribute('data-gallery-index');
      var selectedFigure = viewer.querySelector('[data-gallery-index="' + index + '"]');
      if (!selectedFigure) return;

      viewer.querySelectorAll('[data-gallery-figure]').forEach(function (figure) {
        var selected = figure === selectedFigure;
        figure.setAttribute('data-gallery-selected', selected ? 'true' : 'false');
        figure.setAttribute('aria-hidden', selected ? 'false' : 'true');
        figure.classList.toggle('is-selected', selected);
      });

      navigation.querySelectorAll('[data-gallery-thumbnail]').forEach(function (item) {
        item.setAttribute('data-gallery-selected', item === thumbnail ? 'true' : 'false');
      });
    });
  }

  function checkGalleries() {
    window.setTimeout(function () {
      document.querySelectorAll('[data-product-gallery]').forEach(activateFallback);
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkGalleries);
  } else {
    checkGalleries();
  }

  document.addEventListener('shopify:section:load', checkGalleries);
})();
